import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';

/**
 * Line chart showing exam scores over time with passing threshold.
 */
export default function ScoreTrendChart({ scoreTrend }) {
  if (scoreTrend.length === 0) {
    return (
      <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
        <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Exam Score Trend</h3>
        <div className="flex items-center justify-center h-48 text-gray-500 text-sm">
          Complete an exam to see your score trend.
        </div>
      </div>
    );
  }

  const data = scoreTrend.map((s, i) => ({
    ...s,
    label: `Exam ${i + 1}`,
    shortDate: s.date ? `${s.date.split('-')[1]}/${s.date.split('-')[2]}` : `#${i + 1}`,
  }));

  return (
    <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Exam Score Trend</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis dataKey="shortDate" tick={{ fill: '#9CA3AF', fontSize: 11 }} />
          <YAxis domain={[0, 100]} tick={{ fill: '#9CA3AF', fontSize: 11 }} />
          <Tooltip
            contentStyle={{ backgroundColor: '#1a1a2e', border: '1px solid #374151', borderRadius: 8 }}
            formatter={(value) => [`${value}%`, 'Score']}
          />
          <ReferenceLine y={82.5} stroke="#F39C12" strokeDasharray="5 5" label={{ value: 'Pass (825)', fill: '#F39C12', fontSize: 11 }} />
          <Line
            type="monotone"
            dataKey="percentage"
            stroke="#4A90D9"
            strokeWidth={2}
            dot={({ cx, cy, payload }) => (
              <circle
                key={payload.date}
                cx={cx}
                cy={cy}
                r={5}
                fill={payload.passed ? '#2ECC71' : '#E74C3C'}
                stroke="none"
              />
            )}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
